import React, { useEffect, useState } from "react";
import { Box, Button, Typography, TextField, Checkbox } from "@mui/material";
import "./MobileNumberEntry.scss";
import { Colors } from "../../../styles/constant";
import InputAdornment from "@mui/material/InputAdornment";
import AlertRhombus from "../../../assets/icons/alert-rhombus.svg";
import PolicyAndConditionsComponent from "../../../components/CustomPolicyAndConditionsComponent/PolicyAndConditionsComponent";
import {
  functionalityCodeForGenerateOtpApi,
  GTAScreenType,
  OneLoginProdUrl,
  phoneRegex,
  privacyPolicyTitle,
  REGISTER_BIO_METRIC,
  SCREEN_TYPE,
  termsAndConditionsTitle,
  ABC_ONE_LOGIN_URL,
} from "../../../utils/constants";
import { useLazyStoreUserConsentQuery } from "../../Feature_GeneralAppElements/GeneralAppElements_Api";
import {
  useLazyCheckIfPhonePermissionRequiredQuery,
  useLazyCheckIfUserConsentRequiredQuery,
  useLazyGenerateOtpQuery,
  useLazyGetCustomerLobDetailsQuery,
} from "../Login_Api";
import {
  setCsAndLobDetails,
  updateLoginData,
  updateScreenTag,
} from "../Login_Slice";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import {
  saveCsUserId,
  saveEmailId,
} from "../../../redux-store/reducers/CsAppSlice";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import {
  LoginScreenValues,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import CsLocalStorageUtils from "../../../utils/CsLocalStorageUtils";
import {
  BIOMETRIC_DO_IT_LATER_STATUS,
  eraseCookie,
} from "../../../utils/CSCookieHandler";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import TriggerGTAEvent from "../../../utils/GTA";
import {
  useAppSelector,
  useAppDispatch,
} from "../../../redux-store/CustomReduxHooks";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { T_GenerateOtpPay, T_GetCustomerLobDetailsRes } from "../Login_Types";
import {
  defaultEmptyFun,
  getValidEmailFromCustomerAndLobDetails,
  windowOpen,
} from "../../../utils/helper";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import { isEmpty } from "lodash";
import useWindowSize from "../../../hooks/useWindowSize";

interface ChildComponentProps {
  headerText: string;
  headerText2?: string;
  subheaderText: string;
  onAskConsentValueChange?: (newVal: boolean) => void;
}

const MobileNumberEntry: React.FC<ChildComponentProps> = ({
  headerText,
  headerText2 = "",
  subheaderText,
  onAskConsentValueChange = () => {},
}) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [helperText, setHelperText] = useState<string>("");
  const [isCustomPopupOpen, setIsCustomPopupOpen] = useState<boolean>(false);
  const [finalPolicyAndTermsTitle, setFinalPolicyAndTermsTitle] =
    useState<string>("");
  const [isGenerateOtpRunning, setIsGenerateOtpRunning] =
    useState<boolean>(false);
  const [hasPhnPermission, setHasPhnPermission] = useState<boolean | undefined>(
    undefined
  );
  const [askForConsent, setAskForConsent] = useState(false);
  const [isFetchConsentRunning, setIsFetchConsentRunning] = useState(false);
  const [csLobDetails, setCsLobDetails] =
    useState<T_ApiResponse<T_GetCustomerLobDetailsRes>>();
  const { width } = useWindowSize();
  const [fetchUserConsent] = useLazyCheckIfUserConsentRequiredQuery();
  const [fetchPhonePermission, { data: phonePermissionRes }] =
    useLazyCheckIfPhonePermissionRequiredQuery();
  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const appDispatch = useAppDispatch();
  const [storeUserConsentApi] = useLazyStoreUserConsentQuery();
  const masterData = useAppSelector(
    (state) => state.GeneralAppElementsSlice?.masterData
  );
  const masterDetail = masterData?.masterDetail;
  const loginPermissionValue =
    masterDetail?.["login-permission"]?.[0]?.masterValue;
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const emailIdFromConsent = useAppSelector(
    (state) => state.CsAppSlice.emailId
  );
  const [getCustomerLobDetails, { data: customerAndLobDetailsResponse }] =
    useLazyGetCustomerLobDetailsQuery();

  const checkPhonePermission = async (inputValue: string) => {
    const r = await fetchPhonePermission(inputValue);
    return r.data?.code === API_STATUS_CODE.SUCCESS;
  };

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaLoginMobNumDetails.screenName,
      ScreenType: SCREEN_TYPE.LoginScreenType,
    });
  }, []);

  const handleMobileNumberChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = event.target.value;
    setHelperText("");

    if (/^\d{0,10}$/.test(inputValue)) {
      setMobileNumber(inputValue);
    }
    if (inputValue.length === 10 && phoneRegex.test(inputValue)) {
      setIsFetchConsentRunning(true);
      await fetchCustomerAndLobDetails(inputValue);
      let permissionValue;
      if (loginPermissionValue?.toLowerCase() === "true") {
        permissionValue = await checkPhonePermission(inputValue);
      } else {
        permissionValue = true;
      }
      if (permissionValue) {
        setHasPhnPermission(true);
        const r = await fetchUserConsent(inputValue);
        if (r.data?.code === 1 && r.data?.payload?.CS_USER_ID) {
          appDispatch(saveCsUserId(r.data?.payload.CS_USER_ID));
        }
        if (r.data?.code === 1 && !r.data?.payload?.TNC_CONSENT) {
          appDispatch(saveCsUserId(""));
          setAskForConsent(true);
          onAskConsentValueChange(true);
        } else {
          setAskForConsent(false);
          onAskConsentValueChange(false);
        }
        if (r.data?.code === 1 && r.data?.payload?.EMAIL_ID) {
          appDispatch(saveEmailId(r.data?.payload?.EMAIL_ID));
        } else {
          appDispatch(saveEmailId(""));
        }
      } else {
        setHasPhnPermission(false);
        setTimeout(() => {
          windowOpen(OneLoginProdUrl, "_self");
        }, 5000);
      }
      setIsFetchConsentRunning(false);
    }
  };

  const fetchCustomerAndLobDetails = async (mobileNumber: string) => {
    await getCustomerLobDetails({ mobile: mobileNumber }).then((response) => {
      if (
        response.data?.code === API_STATUS_CODE.SUCCESS &&
        !isEmpty(response.data.payload)
      ) {
        setCsLobDetails(response.data);
        appDispatch(setCsAndLobDetails(response.data));
      }
      if (response.error || response.isError) {
        appDispatch(
          setError({
            error: new Error("Error"),
            message: "getCustomerAndLobDetails API failed",
          })
        );
      }
    });
  };

  const handleBlurMobileNumber = (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    validateInput(event.target.value);
  };

  const validateInput = (mobileInput: string) => {
    if (isEmpty(mobileInput)) return;
    const phoneRegexValue = /^[6-9]\d{9}$/;
    if (!phoneRegexValue.test(mobileInput)) {
      setHelperText("Invalid mobile number");
    } else {
      setHelperText("");
      handleClevertapEvent("formfield", "Mobile Number", mobileInput);
      handleGTMEvent("formfield", "Mobile Number", mobileInput);
    }
  };

  const hitApiAndHandleResponse = async () => {
    triggerCleverTapEvent("serv_login_mob_no_continue_click", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Login Mobile Number Enter Details Screen",
      isPrevPageNameRequired: true,
      ctaText: "continue",
    });
    TriggerGTAEvent("serv_login_mob_no_continue_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "servicing_login_mobile_number_enter_details_screen",
      CTA_text: "continue",
    });
    setIsGenerateOtpRunning(true);
    let isGenerateOtpApiCall = false;
    if (askForConsent) {
      await storeUserConsentApi({
        mobile: mobileNumber,
        termsAndConditionConsent: "true",
        privacyConsent: "true",
      }).then((response) => {
        if (response.data?.code === 0 || response.data?.code == 2) {
          appDispatch(
            setError({
              error: response.data,
              message: "API failed",
            })
          );
          setIsGenerateOtpRunning(false);
          isGenerateOtpApiCall = false;
          return;
        } else if (
          response.data?.code === 1 &&
          response.data?.payload?.csUserId
        ) {
          appDispatch(saveCsUserId(response.data?.payload.csUserId));
        } else {
          appDispatch(saveCsUserId(""));
        }
        isGenerateOtpApiCall = true;
      });
    } else {
      isGenerateOtpApiCall = true;
    }
    if (isGenerateOtpApiCall) {
      const requestParams: T_GenerateOtpPay = {
        mobileNo: "" + mobileNumber,
        otp: "",
        functionality: functionalityCodeForGenerateOtpApi,
      };
      // Add emailId to requestParams only if it's not empty from fetchConsent api response
      if (emailIdFromConsent && emailIdFromConsent.trim() !== "") {
        requestParams.emailId = emailIdFromConsent;
      }
      // Set emailID when we received from customerAndLobDetails API response
      let customerAndLobDetails =
        csLobDetails?.payload.customerAndLobDetails || [];

      let customerEmailFromLobDetails = getValidEmailFromCustomerAndLobDetails(
        customerAndLobDetails
      );
      if (!isEmpty(customerEmailFromLobDetails)) {
        requestParams.emailId = customerEmailFromLobDetails;
        CsLocalStorageUtils.set("EMAIL", customerEmailFromLobDetails);
      }
      await generateOtpApi(requestParams).then((res) => {
        if (!res.error && res.data?.code === API_STATUS_CODE.SUCCESS) {
          appDispatch(
            updateLoginData({
              key: "mobilenumber",
              value: mobileNumber,
            })
          );
          if (headerText == "Forgot mPIN") {
            appDispatch(
              updateScreenTag(LoginScreenValues.enterMobileScreenForgotPin)
            );
          } else {
            if (CsLocalStorageUtils.get("MOBILE") !== mobileNumber) {
              Object.keys(localStorage)
                .filter((key) => !key.startsWith("WZRK_")) // Filter out keys that don't start with "WZRK."
                .forEach((key) => localStorage.removeItem(key));
              eraseCookie(BIOMETRIC_DO_IT_LATER_STATUS);
              eraseCookie(REGISTER_BIO_METRIC);
              CsLocalStorageUtils.set("MOBILE", mobileNumber);
            }
            appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreen));
          }
        } else if (
          res.error &&
          (res.error as T_ApiResponse<any>)?.code ===
            API_STATUS_CODE.BUSINESS_ERROR
        ) {
          setHelperText((res.error as T_ApiResponse<any>)?.uiDisplayMessage);
        } else {
          appDispatch(
            setError({
              error: (res.error as T_ApiResponse<any>) || Error("Failed!"),
              message: "API failed",
            })
          );
        }
        setIsGenerateOtpRunning(false);
      });
    }
  };

  const handlePolicyTermsPopup = (title: string) => {
    setIsCustomPopupOpen(true);
    title === termsAndConditionsTitle
      ? setFinalPolicyAndTermsTitle(termsAndConditionsTitle)
      : setFinalPolicyAndTermsTitle(privacyPolicyTitle);
  };

  let isButtonDisabled =
    !mobileNumber ||
    !phoneRegex.test(mobileNumber) ||
    (askForConsent && !checked) ||
    !hasPhnPermission;
  const handleClevertapEvent = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string
  ) => {
    triggerCleverTapEvent("serv_login_mob_no_form_field", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Login Mobile Number Enter Details Screen",
      isPrevPageNameRequired: true,
      FormFieldTitle: formFieldTitle,
      FormFieldValue: formFieldValue,
    });
  };

  const handleGTMEvent = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string
  ) => {
    TriggerGTAEvent("serv_login_mob_no_form_field", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "servicing_login_mobile_number_enter_details_screen",
      isPrevPageNameRequired: true,
      field_placeholder_text: formFieldTitle,
      field_placeholder_value: formFieldValue,
    });
  };

  const handleClevertapEventOneID = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string
  ) => {
    triggerCleverTapEvent("serv_login_with_one_id_&_pass_cta_click", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "servicing_login_mobile_number_enter_details_screen",
      isPrevPageNameRequired: true,
      FormFieldTitle: formFieldTitle,
      FormFieldValue: formFieldValue,
    });
  };

  const handleGTMEventOneID = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string
  ) => {
    TriggerGTAEvent("serv_login_with_one_id_&_pass_cta_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "servicing_login_mobile_number_enter_details_screen",
      isPrevPageNameRequired: true,
      field_placeholder_text: formFieldTitle,
      field_placeholder_value: formFieldValue,
    });
  };

  const handleLoginWithOneIdClick = async () => {
    handleClevertapEventOneID(
      "",
      "login_with_one_id_and_password",
      "login_with_one_id_and_password"
    );
    handleGTMEventOneID(
      "",
      "login_with_one_id_and_password",
      "login_with_one_id_and_password"
    );
    window.location.href = ABC_ONE_LOGIN_URL;
  };

  if (hasPhnPermission === false) {
    return (
      <CustomPopup
        open={true}
        handleOpen={defaultEmptyFun}
        children={
          <Box
            alignItems={"center"}
            padding={"1rem"}
            className="terms-and-condition-wrapper"
          >
            <Typography
              textAlign={"center"}
              marginBottom={"1.5rem"}
              variant="h6"
              letterSpacing={".0938rem"}
              fontFamily={"PoppinsSemiBold"}
              color={Colors.darkCharcoal}
              className="tac-title"
            >
              {phonePermissionRes?.payload?.uiDisplayMessage ||
                `We're Coming Soon! Stay Tuned for Something Amazing`}
            </Typography>
          </Box>
        }
      ></CustomPopup>
    );
  }

  let isWeb = width > 900;

  return (
    <Box
      className="enter-mobile-number-wrapper"
      minWidth={"12.5rem"}
      width={"100%"}
      maxWidth={"23.9375rem"}
    >
      <Typography
        fontWeight={700}
        fontSize={{ xs: "1.25rem", md: "1.5rem" }}
        lineHeight={{ xs: "1.375rem", md: "1.8rem" }}
      >
        {headerText + (isWeb ? "" : headerText2)}
      </Typography>
      {headerText2 && isWeb && (
        <Typography
          fontWeight={700}
          fontSize={{ xs: "1.25rem", md: "1.5rem" }}
          lineHeight={{ xs: "1.375rem", md: "1.8rem" }}
        >
          {headerText2}
        </Typography>
      )}
      {/* <Typography marginTop="0.5rem" variant="body1" color="#797979">
        {subheaderText}
      </Typography> */}

      <TextField
        fullWidth
        autoFocus
        placeholder="Enter your mobile number"
        label="Mobile Number"
        variant="outlined"
        value={mobileNumber}
        onBlur={handleBlurMobileNumber}
        onChange={handleMobileNumberChange}
        error={helperText.length > 0}
        disabled={isFetchConsentRunning || isGenerateOtpRunning}
        inputProps={{
          maxLength: 10,
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        helperText={
          <span style={{ display: "flex", alignItems: "center" }}>
            <InputAdornment component="span" position="start">
              {helperText.length > 0 && (
                <img src={AlertRhombus} loading="lazy" />
              )}
            </InputAdornment>
            {helperText}
          </span>
        }
        sx={{ marginTop: { xs: "1.375rem", md: "1.5rem" } }}
      />
      {headerText === "Welcome," && askForConsent && (
        <Box marginTop="1rem" display="flex" alignItems="center">
          <Checkbox
            checked={checked}
            inputProps={{ "aria-label": "custom checkbox" }}
            onChange={(event) => {
              setChecked(event.target.checked);
              handleClevertapEvent(
                "formfield",
                "I agree with Terms & Conditions and Privacy Policy",
                `${event.target.checked}`
              );
              handleGTMEvent(
                "formfield",
                "I agree with Terms & Conditions and Privacy Policy",
                `${event.target.checked}`
              );
            }}
            size="small"
            sx={{
              padding: 0,
              color: Colors.red,
              "&.Mui-checked": {
                color: Colors.red,
              },
            }}
          />

          <Typography
            fontSize={{ xs: 14, md: 12 }}
            fontWeight={500}
            marginLeft={{ xs: ".25rem", md: "0.75rem" }}
          >
            I agree with
            <span
              style={{ color: Colors.red, cursor: "pointer" }}
              onClick={() => handlePolicyTermsPopup(termsAndConditionsTitle)}
            >
              {" "}
              Terms & Conditions{" "}
            </span>
            and
            <span
              style={{ color: Colors.red, cursor: "pointer" }}
              onClick={() => handlePolicyTermsPopup(privacyPolicyTitle)}
            >
              {" "}
              Privacy Policy{" "}
            </span>
          </Typography>
        </Box>
      )}

      <Box
        display="flex"
        justifyContent="center"
        marginTop={{ xs: askForConsent ? "1rem" : "1.5rem", md: "2.5rem" }}
      >
        {isGenerateOtpRunning || isFetchConsentRunning ? (
          <CustomThreeDotsLoader withText={true} />
        ) : (
          <Button
            disabled={isButtonDisabled}
            fullWidth
            variant="contained"
            sx={{
              borderRadius: "1.25rem",
              padding: ".875rem 0",
            }}
            onClick={hitApiAndHandleResponse}
          >
            Send OTP
          </Button>
        )}
      </Box>
      {/*commented for now, un-comment it later if needed*/}
      {/* {isEmpty(csAppSlice.NativeDeviceInfo?.deviceName) && (  
        <Box display="flex" justifyContent="center">
          <Typography
            fontSize={14}
            marginTop="1.125rem"
            fontWeight={600}
            lineHeight={".975rem"}
            color={"rgba(199, 34, 42, 1)"}
            align="center"
            style={{ cursor: "pointer" }}
            onClick={handleLoginWithOneIdClick}
          >
            {"Login with One ID and Password"}
          </Typography>
        </Box>
      )} */}

      {isCustomPopupOpen && (
        <PolicyAndConditionsComponent
          open={isCustomPopupOpen}
          handleOpen={setIsCustomPopupOpen}
          title={finalPolicyAndTermsTitle}
        />
      )}
    </Box>
  );
};

export default MobileNumberEntry;
